<template>
  <v-card class="payment-method-card" elevation="0">
      <div class="payment-header">
        <div>
          <div class="payment-title">Payment methods</div>
          <div class="payment-subtitle">Cards and bank accounts available for school fee payments</div>
        </div>
        <v-spacer></v-spacer>
        <div class="payment-actions" v-if="customer">
            <CardOnFile :id="customer.id" :type="type" @submit="reload()" :selectedMerchant="selectedMerchant" />
            <CreditCard v-if="type === 'customer'" :Cards="cards" @getCard="getCard" :customer="customer" @submit="reload"
              :stripeId="customer.stripeId"></CreditCard>
            <CreditCard v-else :Cards="cards" @getCard="getCard" :donor="customer" @submit="reload"
              :stripeId="customer.stripeId"></CreditCard>
        </div>
      </div>

      <div class="merchant-selector">
        <v-select dense outlined hide-details :items="MerchantAccount" v-model="selectedMerchant" return-object item-text="name"
          label="Fee account"></v-select>
      </div>

      <v-progress-linear v-if="isLoading" indeterminate color="primary" />

      <div v-if="!isLoading && cards && cards.length" class="saved-methods">
        <div v-for="(card, index) in cards" :key="card.id || index" class="saved-method">
          <div class="method-icon"><v-icon color="primary">{{ card.payment_method_type === 'ach' ? 'mdi-bank-outline' : 'mdi-credit-card-outline' }}</v-icon></div>
          <div class="method-info">
            <strong><span v-if="card.card_type">{{ card.card_type }}</span><span v-else-if="card.account_type">{{ card.account_type }}</span> ending in {{ card.last4 }}</strong>
            <span><span v-if="card.expiry_month">Expires {{ card.expiry_month }}/{{ card.expiry_year }} · </span>Added {{ card.created_at | moment("L") }}</span>
          </div>
          <v-chip x-small color="primary" outlined class="text-capitalize">{{ card.payment_method_type }}</v-chip>
          <div>
                  <v-menu bottom right offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon aria-label="Payment method actions">
                        <v-icon>mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item @click="deleteCard(card)">
                        <v-list-item-icon><v-icon size="18">mdi-delete-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Remove payment method</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
          </div>
        </div>
      </div>
      <div v-else-if="!isLoading" class="payment-empty">
        <v-icon color="#9BA69C" size="32">mdi-credit-card-off-outline</v-icon>
        <strong>No payment methods added</strong>
        <span>Add a card or bank account for future fee payments.</span>
      </div>
  </v-card>
</template>

<script>
import donationCategoryService from "@/modules/DonationCategory/service.js";
import payCompassService from "@/modules/PayCompass/service.js";
import { mapGetters } from "vuex";
const CreditCard = () => import("@/modules/Customer/components/CreditCard.vue");
const CardOnFile = () => import("@/modules/SecretManager/components/CardsOnFile.vue");

export default {
  name: "Paymentmethod-list",
  props: ['type', 'customer'],
  data() {
    return {
      selectedMerchant: null,
      MerchantAccount: [],
      cards: [],
      isLoading: false,
    };
  },
  computed: {
    // ...mapGetters("customer", ["customer"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus", 'currentBusiness']),
  },
  components: {
    CreditCard,
    CardOnFile,
  },
  async created() {
    await this.getDonationCategoryList();
  },
  watch: {
    selectedMerchant(val) {
      // console.log('val', val)
      // console.log('customer', customer)
      if (val) {
        // this.cards = []
        this.getCard()
      }

    },
  },
  methods: {
    async reload() {
      this.isLoading = true
      if (this.selectedMerchant) {
        this.getCard()
      }

    },
    deleteCard(card) {
    this.$swal({
        title: "Remove payment method?",
        text: `The payment method ending in ${card.last4} will no longer be available.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Remove",
      }).then((result) => {
        if (result.value) {

          payCompassService.deleteCard({ id: card.id, donationCategoryId: this.selectedMerchant.id }).then(result => {
            console.log('result', result)
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Payment method removed",
              });
            this.reload()
          })
        }
      });

    },
    getCard() {
      this.cards = []
      this.isLoading = true
      //console.log('get card customer', this.customer, this.selectedMerchant)
      let payCompassId = null
      this.customer.MerchantCustomers.map(row => {
        if (row.DonationCategoryId === this.selectedMerchant.id) {
          payCompassId = row.payCompassId
        }
      })
      // console.log('payCompassId', payCompassId)
      if (payCompassId) {
        // console.log('i am getting card')
        payCompassService.getAllCard(payCompassId, { donationCategoryId: this.selectedMerchant.id }).then(response => {
          // console.log('card response', response)
          if (response.data.length) {
            this.cards = response.data
          }

          this.isLoading = false
        }).catch(error => {
          console.log('error', error)
          this.isLoading = false
        })
      } else {
        this.isLoading = false
      }
    },
    getDonationCategoryList() {
      return donationCategoryService.getAll().then((response) => {
        //console.log('response merchant', response)
        this.MerchantAccount = response.data;
        if (this.type === 'customer') {
          this.MerchantAccount.map(row => {
            if (row.id === this.currentBusiness.DefaultSchoolFeeId) {
              this.selectedMerchant = row
            }
          })
        } else {
          this.MerchantAccount.map(row => {
            if (row.id === this.currentBusiness.DefaultDonationId) {
              this.selectedMerchant = row
            }
          })
        }
        this.getCard()
      });
    },
  }
}
</script>

<style scoped>
.payment-method-card { border: 1px solid #e3e9e3; border-radius: 11px !important; overflow: hidden; }
.payment-header { display: flex; align-items: center; gap: 12px; padding: 15px 17px; border-bottom: 1px solid #edf0ed; }
.payment-title { color: #28362c; font-size: 14px; font-weight: 750; }
.payment-subtitle { margin-top: 2px; color: #879388; font-size: 10px; }
.payment-actions { display: flex; gap: 7px; }
.merchant-selector { max-width: 360px; padding: 14px 17px; }
.merchant-selector ::v-deep .v-input__slot { border-radius: 8px !important; }
.saved-methods { border-top: 1px solid #edf0ed; }
.saved-method { display: grid; grid-template-columns: 42px minmax(0, 1fr) auto 38px; align-items: center; gap: 12px; min-height: 70px; padding: 12px 16px; border-bottom: 1px solid #edf0ed; }
.saved-method:last-child { border-bottom: 0; }
.method-icon { display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 10px; background: #eaf6eb; }
.method-info { display: flex; min-width: 0; flex-direction: column; }
.method-info strong { color: #35433a; font-size: 12px; text-transform: capitalize; }
.method-info span { margin-top: 3px; color: #89948a; font-size: 10px; }
.payment-empty { display: flex; min-height: 145px; align-items: center; justify-content: center; flex-direction: column; gap: 5px; color: #647067; text-align: center; }
.payment-empty strong { font-size: 12px; }
.payment-empty span { color: #929d94; font-size: 10px; }
@media (max-width: 599px) {
  .payment-header { align-items: flex-start; }
  .payment-subtitle { max-width: 190px; }
  .saved-method { grid-template-columns: 40px minmax(0, 1fr) 34px; }
  .saved-method .v-chip { display: none; }
}
</style>
